import React, { useState, useEffect, useMemo } from 'react';
import ReactLoading from 'react-loading';
import TelegramSafeArea from '../../../../Components/TelegramSafeArea';
import api from '../../../../hooks/api'; // اطمینان حاصل کنید مسیر api صحیح است
import { toPersianDigits, formatDate, getUserRoleInfo } from '../utils';

export const OrderHistoryModal = ({ isOpen, onClose, invoiceId, orderFactor }) => {
    const [historyData, setHistoryData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const fetchHistory = async () => {
            if (!isOpen || !invoiceId) return;

            setIsLoading(true);
            setHistoryData([]);

            try {
                const response = await api.post(`invoice/reporter/history?page=1`, { 
                    invoice_id: invoiceId 
                });
                
                let rawHistoryList = [];
                const resData = response?.data;

                if (resData) {
                    if (resData.data && Array.isArray(resData.data.data)) {
                        rawHistoryList = resData.data.data;
                    } else if (Array.isArray(resData.data)) {
                        rawHistoryList = resData.data;
                    } else if (Array.isArray(resData)) {
                        rawHistoryList = resData;
                    }
                }

                if (isMounted) {
                    setHistoryData(rawHistoryList);
                }
            } catch (error) {
                console.error("Error fetching history:", error);
            } finally {
                if (isMounted) {
                    setIsLoading(false);
                }
            }
        };

        fetchHistory();

        return () => {
            isMounted = false;
        };
    }, [isOpen, invoiceId]);

    const groupedHistory = useMemo(() => {
        if (!historyData || historyData.length === 0) return [];

        const groups = [];
        historyData.forEach(item => {
            const statusTitle = item.status?.title || 'نامشخص';
            let group = groups.find(g => g.status_title === statusTitle);

            if (!group) {
                group = { status_title: statusTitle, items: [] };
                groups.push(group);
            }
            group.items.push(item);
        });

        return groups;
    }, [historyData]);

    if (!isOpen) return null;

    return (
        <div className="modal-backdrop" onClick={onClose} style={{ zIndex: 1200 }}>
            <div className="history-modal-content" onClick={e => e.stopPropagation()}>
                <TelegramSafeArea style={{ background: "#ffffff", color: "#000", borderTopLeftRadius: 'inherit', borderTopRightRadius: 'inherit' }}>
                    <div className="safe-area-title" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', lineHeight: '1.3', padding: '5px 0' }}>
                        <span style={{ fontSize: '15px', fontWeight: 'bold' }}>سبد 1</span>
                        <span style={{ fontSize: '12px', opacity: 0.85 }}>فروشگاه آنلاین</span>
                    </div>
                </TelegramSafeArea>

                <div className="history-modal-header">
                    <h3>تاریخچه و گفتگوهای سفارش: {toPersianDigits(orderFactor)}</h3>
                    <button className="close-btn-simple" onClick={onClose}>✕</button>
                </div>

                <div className="history-modal-body">
                    <div className="history-content-wrapper">
                        {isLoading ? (
                            <div className="loading-center">
                                <ReactLoading type="spin" color="#3b82f6" height={40} width={40} />
                                <span style={{ marginTop: '15px', fontSize: '13px', color: '#64748b' }}>در حال دریافت سوابق...</span>
                            </div>
                        ) : (
                            <>
                                {groupedHistory && groupedHistory.length > 0 ? (
                                    <div className="timeline-container">
                                        {groupedHistory.map((statusGroup, sIndex) => (
                                            <div key={sIndex} className="timeline-status-group">
                                                <div className="timeline-status-separator">
                                                    {statusGroup.status_title}
                                                </div>

                                                {statusGroup.items.map((reportGroup, index) => {
                                                    const reporterInfo = getUserRoleInfo(reportGroup.reporter_group_id);
                                                    return (
                                                        <div key={index} className="timeline-item">
                                                            <div className="timeline-marker"></div>
                                                            <div className="timeline-content">
                                                                <div className="timeline-report-box">
                                                                    <div className={`user-badge ${reporterInfo?.className || ''}`}>
                                                                        {reporterInfo?.title || reportGroup.reporter_group?.title || 'کاربر'}
                                                                    </div>
                                                                    <p className="timeline-text">{toPersianDigits(reportGroup.report_text)}</p>
                                                                    <span className="timeline-date">
                                                                        {reportGroup.created_at ? toPersianDigits(formatDate(reportGroup.created_at)) : '-'}
                                                                    </span>
                                                                </div>
                                                                {reportGroup.respondents?.length > 0 && (
                                                                    <div className="responses-container">
                                                                        {reportGroup.respondents.map((resp, rIndex) => {
                                                                            const responderInfo = getUserRoleInfo(resp.reporter_group_id);
                                                                            return (
                                                                                <div key={rIndex} className="timeline-response-box">
                                                                                    <div className={`user-badge ${responderInfo?.className || ''}`}>
                                                                                        ↲ پاسخ {responderInfo?.title || 'کاربر'}
                                                                                    </div>
                                                                                    <p className="response-text">{toPersianDigits(resp.response_text)}</p>
                                                                                    <span className="timeline-date">
                                                                                        {resp.created_at ? toPersianDigits(formatDate(resp.created_at)) : ''}
                                                                                    </span>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="empty-state-history">هیچ سابقه یا گفتگویی برای نمایش یافت نشد.</div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
